import React from 'react'

function EventHeading({ event }) {
  let zoneDisplay = event.chosenZone ? ': ' + event.chosenZone.description : ''
  return (
    <div className="pt-8 pb-24">
      {event.name && (
        <h3>
          {event.name}
          {zoneDisplay}
        </h3>
      )}
      {event.description && (
        <p
          className="text-16"
          dangerouslySetInnerHTML={{ __html: event.description }}
        >
          {}
        </p>
      )}
    </div>
  )
}

export default EventHeading
